import { createApp } from 'vue';
import App from './App.vue';
import './assets/main.css';

// Import global components
import HUD from './components/HUD.vue';
import WeaponHUD from './components/WeaponHUD.vue';
import Scoreboard from './components/Scoreboard.vue';
import HealthBar from './components/HealthBar.vue';
import WeaponSelector from './components/WeaponSelector.vue';

// Create the Vue application
const app = createApp(App);

// Register components globally to ensure they're available everywhere
app.component('HUD', HUD);
app.component('WeaponHUD', WeaponHUD);
app.component('Scoreboard', Scoreboard);
app.component('HealthBar', HealthBar);
app.component('WeaponSelector', WeaponSelector);

// Add error handler for debugging
app.config.errorHandler = (err, vm, info) => {
  console.error('Vue Error:', err);
  console.error('Info:', info);
};

// Log a message when components are mounted
app.mixin({
  mounted() {
    console.log(`Component ${this.$options.name} mounted`);
  }
});

// Mount the app to the DOM
app.mount('#app');

console.log('Vue app initialized and mounted to #app'); 